// extracted by mini-css-extract-plugin
export var bulkPurchaseTable = "_e-0";